export const examAdminAuth = {
  login: {
    pageTitle: "管理后台登录",
    documentTitle: "{platformName} · 管理后台登录",
    shellSubtitle: "AI Exam 管理后台",
    portalLabel: "管理后台入口",
    title: "登录管理后台（{platformName}）",
    shellDescriptionSso: "优先使用统一身份登录。若你已从门户进入，页面会自动接管当前会话。",
    shellDescriptionHybrid: "支持统一身份与本地账号两种登录方式，建议优先使用统一身份。",
    shellDescriptionLocal: "当前为本地登录模式，可使用本地账号进入考试管理后台。",
    devAccounts: "可用本地账号：{accounts}",
    maintenanceNotice: "站点维护中：考试端不可用，管理后台仍可登录维护。",
    noPortalAccess: "当前账号没有管理后台访问权限",
    noResolvedSsoSession: "当前没有可用的统一身份会话",
    captchaRequired: "请先完成验证码验证",
    ipNotAllowed: "IP 不在允许范围",
    refreshCaptcha: "刷新验证码",
    submit: "登录",
    authSourceLabel: "登录方式",
    authSourceHintHybrid: "当前支持本地账号与统一身份双通道登录。",
    authSourceHintSso: "当前管理后台已切换为统一身份登录。",
    authSourceHintLocal: "当前实例仅开放本地登录。",
    bootstrapCheckingTitle: "正在检查统一身份登录状态...",
    bootstrapCheckingDescription: "如果你已从门户进入，系统会自动跳过此页。",
    currentUnifiedIdentityTitle: "当前统一身份",
    currentUnifiedIdentityDescription: "使用统一身份登录后，可直接进入考试管理后台。",
    resolvedSsoUserDescription: "已检测到当前统一身份，可快捷进入考试管理后台",
    resolvedSsoUsernameLabel: "统一身份账号",
    resolvedSsoRoleLabel: "角色",
    enterWithResolvedSsoUser: "以当前身份进入",
    noResolvedSsoSessionTitle: "未检测到统一身份会话",
    noResolvedSsoSessionDescription: "请先从门户登录，或确认统一身份中心当前可用。",
    openPortal: "打开门户",
    openCandidatePortal: "打开考生端",
    highlightUnifiedEntry: "统一管理后台入口",
    highlightRoleAccess: "角色权限收口",
    highlightMaintainable: "系统维护可控",
  },
  changePassword: {
    sectionLabel: "安全策略",
    title: "修改登录密码",
    description: "账号 {username} 需要先修改密码后才能继续使用管理后台。",
    success: "密码修改成功",
    mismatch: "两次输入的新密码不一致",
    newPasswordMustDiffer: "新密码不能与当前密码相同",
    submit: "保存新密码",
    highlightUnifiedShell: "统一认证壳层",
    highlightPolicy: "密码策略生效",
    highlightSession: "当前会话同步",
  },
};
